<template>
  <div>
    <!-- Layout pour AquariumPage avec noButton -->
    <div v-if="props.noButton" class="mx-6 mt-0 mb-4 blue-block">
      <div class="text-white">
        <div v-if="props.label" class="text-xl font-semibold mb-2">
          {{ props.label }}
        </div>

        <div v-if="!aquariums || !aquariums.list || aquariums.list.length === 0">
          <span class="text-baseplus" :style="{ color: '#8CA0DF' }">
            {{ $t("aquarium.none") }}
          </span>
        </div>

        <div v-else-if="!props.subtitleName" class="flex items-start gap-4">
          <!-- Dropdown aquariums -->
          <div class="flex-grow">
            <blue-dropdown
              :options="aquaList"
              :modelValue="current"
              @update:modelValue="(val) => select(val)"
              item-text="label"
              item-value="value"
              :placeholder="$t('aquarium.select')"
              interface="popover"
              :gradient="true"
            />
            <div class="text-base text-white mt-1" v-if="currentAquarium">
              {{ currentAquarium.model }}
            </div>
          </div>

          <!-- Icônes : photos, aquarium camera, options, partage -->
          <div class="flex items-center gap-3 shrink-0" style="margin-top: 8px;">
            <div v-if="props.photosButton" class="cursor-pointer" @click="$emit('click-photos')">
              <img
                src="/assets/micons/ic_fluent_camera_add_24_filled.svg"
                class="w-[24px] h-[24px]"
                style="filter: brightness(0) invert(1)"
              />
            </div>
            <div v-if="props.optionsButton" class="cursor-pointer" @click="$emit('click-settings')">
              <img
                src="/assets/micons/ic_fluent_settings_24_filled.svg"
                class="w-[24px] h-[24px]"
              />
            </div>
            <div v-if="props.cameraButton" class="cursor-pointer camera-wrap" @click="$emit('click-camera')">
              <div class="sparkle-container" :class="isFreshWater ? 'sparkle-fresh' : 'sparkle-reef'">
                <span class="sparkle s1"></span>
                <span class="sparkle s2"></span>
                <span class="sparkle s3"></span>
                <span class="sparkle s4"></span>
                <span class="sparkle s5"></span>
                <span class="sparkle s6"></span>
              </div>
              <div class="camera-btn-glow" :class="isFreshWater ? 'camera-fresh' : 'camera-reef'">
                <img
                  src="/assets/micons/ic_camera_sparkle.svg"
                  class="w-[22px] h-[22px] camera-icon-white"
                />
              </div>
            </div>
            <div
              v-if="
                currentAquarium &&
                currentAquarium.config &&
                !currentAquarium.config.disable_share
              "
              class="cursor-pointer"
              @click="clickShare"
            >
              <ion-icon :icon="$icons.shareSocial" class="text-white text-[24px]"></ion-icon>
            </div>
          </div>
        </div>

        <div v-else-if="props.subtitleName">
          <span class="text-baseplus" :style="{ color: '#8CA0DF' }">
            {{ currentAquarium?.name }}
          </span>
        </div>
      </div>
    </div>

    <!-- Layout original avec bouton retour -->
    <div v-else :class="props.blueBlock ? 'mx-6 mt-4 mb-4 blue-block' : ''">
    <div
      class="flex items-center text-white"
      :class="[props.blueBlock ? 'py-2' : 'py-6 px-6']"
      :style="{ 'background-color': '#00000000' }"
    >
      <div
        class="shrink-0 flex items-center cursor-pointer button-return transition-all duration-500"
        :style="{
          width: '42px',
          height: '42px',
          'border-radius': '24px',
          backgroundColor: isFreshWater ? '#1B8A4A' : '#1052D8',
          color: '#ffffff',
        }"
        @click="back"
      >
        <ion-icon
          :icon="$icons.chevronBackOutline"
          :style="{ 'padding-left': '7px' }"
          class="text-2xl text-center font-bold"
        ></ion-icon>
      </div>
      <div
        class="grow text-xl font-semibold tracking-tighter pl-4"
      >
        <div v-if="props.label">
          {{ props.label }}
        </div>
        <div class="flex items-center gap-1 tracking-tight font-normal">
          <span
            v-if="subtitle"
            class="text-baseplus inline-block"
            :style="{ color: 'var(--text-highlight)' }"
            >{{ subtitle }}</span
          >
          <span
            class="text-baseplus inline-block"
            :style="{ color: '#8CA0DF' }"
            v-else-if="
              !aquariums || !aquariums.list || aquariums.list.length === 0
            "
            >{{ $t("aquarium.none") }}</span
          >
          <div v-else>
            <span
              v-if="props.subtitleName"
              class="text-baseplus inline-block"
              :style="{ color: '#8CA0DF' }"
              >{{ currentAquarium?.name }}</span
            >
            <div class="flex items-center justify-start py-1 gap-2" v-else>
              <blue-dropdown
                :options="aquaList"
                :modelValue="current"
                @update:modelValue="(val) => select(val)"
                item-text="label"
                item-value="value"
                :placeholder="$t('aquarium.select')"
                interface="popover"
                :gradient="true"
              />
              <div class="flex items-center gap-2">
                <ion-fab
                  v-if="props.photosButton"
                  class="block relative"
                  @click="$emit('click-photos')"
                >
                  <ion-fab-button size="small">
                    <ion-icon :icon="$icons.camera"></ion-icon>
                  </ion-fab-button>
                </ion-fab>
                <ion-fab
                  v-if="props.optionsButton"
                  class="block relative"
                  @click="$emit('click-settings')"
                >
                  <ion-fab-button size="small">
                    <ion-icon :icon="$icons.settings"></ion-icon>
                  </ion-fab-button>
                </ion-fab>
                <div
                  v-if="
                    currentAquarium &&
                    currentAquarium.config &&
                    !currentAquarium.config.disable_share
                  "
                  class="flex items-center justify-center cursor-pointer rounded-full"
                  :style="{
                    width: '28px',
                    height: '28px',
                    backgroundColor: isFreshWater ? '#1B8A4A' : '#1052D8',
                  }"
                  @click="clickShare"
                >
                  <ion-icon :icon="$icons.shareSocial" class="text-white text-[16px]"></ion-icon>
                </div>
              </div>
            </div>

            <div class="text-base text-bluegrey" v-if="currentAquarium">
              {{ currentAquarium.model }}
            </div>
          </div>
        </div>
      </div>
      <BubbleFish v-if="!props.hideFish" class="shrink-0" />
    </div>
    </div>
  </div>
</template>
<script setup>
import { computed, onMounted, watch } from "vue";
import { IonFab, IonFabButton, useIonRouter } from "@ionic/vue";
import BubbleFish from "../BubbleFish.vue";
import { useAquariums } from "@/store/useAquariums.js";
import { useRoute } from "vue-router";
import { Share } from "@capacitor/share";
import { useI18n } from "vue-i18n";
import { useAnalytics } from "@/composable/useAnalytics";
import { useSubscribe } from "@/composable/useSubscribe";
import { useDomain } from "@/composable/useDomain.js";

const { isFreshWater } = useDomain();

const { t } = useI18n();
const aquariums = useAquariums();

const { event } = useAnalytics();

onMounted(() => {
  aquariums.loadAquariums();
});

const route = useRoute();
const currentId = computed(() =>
  route.params.id
    ? route.params.id == "new"
      ? "new"
      : Number(route.params.id)
    : null
);

watch(
  () => currentId.value,
  (n) => {
    if (n) {
      aquariums.setCurrent(n);
    }
  },
  { immediate: true }
);

const current = computed(() => "" + aquariums?.currentId);
const aquaList = computed(() => {
  const res = [{ value: -1, label: t("aquarium.new") }];
  aquariums?.list?.forEach((ent) => {
    res.push({
      value: "" + ent.id,
      label: ent.name,
    });
  });
  return res;
});

const currentAquarium = computed(() => {
  return aquariums?.list?.find((a) => a.id == currentId.value);
});

const props = defineProps({
  label: String,
  subtitle: String,
  noButton: Boolean,
  backCall: Function,
  backRoute: String,
  subtitleName: Boolean,
  photosButton: Boolean,
  cameraButton: Boolean,
  optionsButton: Boolean,
  hideFish: Boolean,
  blueBlock: Boolean,
});

const emit = defineEmits(["click-photos", "click-camera", "click-settings"]);

const clickShare = async () => {
  event("share");
  const perm = await Share.canShare();
  const opts = {
    title: currentAquarium.value?.name,
    url: "https://p.bluereef.app/" + currentAquarium.value?.token,
    dialogTitle: t("share.dialogtitle"),
  };
  if (perm.value) {
    await Share.share(opts);
  } else {
    console.log("Can not share", opts);
  }
};
const ionRouter = useIonRouter();
const back = () => {
  if (props.backCall != null) {
    props.backCall();
  } else if (props.backRoute != null) {
    ionRouter.navigate(props.backRoute, "backward", "replace");
  } else {
    ionRouter.back();
  }
};
const { controlPremiumAndBlock } = useSubscribe();
const select = (val) => {
  if (current.value != val) {
    // go to aqaurium page
    const id = Number(val);
    if (id == -1) {
      if (controlPremiumAndBlock()) {
        ionRouter.push("/aquarium/new/edit");
      }
    } else if (!isNaN(id)) {
      aquariums.setCurrent(val);
      if (route.path.indexOf("/measures") > 0) {
        ionRouter.push("/aquarium/" + val + "/measures");
      } else if (route.path.indexOf("/tasks") > 0) {
        ionRouter.push("/aquarium/" + val + "/tasks");
      } else if (route.path.indexOf("/edit") > 0) {
        ionRouter.push("/aquarium/" + val + "/edit");
      } else if (route.path.indexOf("/bailing") > 0) {
        ionRouter.push("/aquarium/" + val + "/bailing");
      } else if (route.path.indexOf("/lab") > 0) {
        ionRouter.push("/aquarium/" + val + "/lab");
      } else {
        ionRouter.push("/aquarium/" + val);
      }
    }
  }
};
</script>
<style>
.button-return:hover {
  color: white !important;
}

.camera-btn-glow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  position: relative;
  overflow: hidden;
  animation: camera-pulse 2.5s ease-in-out infinite;
}

.camera-reef {
  background: linear-gradient(135deg, #1052D8 0%, #3b7dff 50%, #2eded1 100%);
  background-size: 200% 200%;
  animation: camera-pulse 2.5s ease-in-out infinite, camera-gradient-shift 4s ease infinite;
}

.camera-fresh {
  background: linear-gradient(135deg, #1B8A4A 0%, #3FC668 50%, #2ecda7 100%);
  background-size: 200% 200%;
  animation: camera-pulse 2.5s ease-in-out infinite, camera-gradient-shift 4s ease infinite;
}

.camera-icon-white {
  filter: brightness(0) invert(1);
  position: relative;
  z-index: 1;
}

@keyframes camera-pulse {
  0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(255,255,255,0.2); }
  50% { transform: scale(1.08); box-shadow: 0 0 8px 2px rgba(255,255,255,0.15); }
}

@keyframes camera-gradient-shift {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

/* Sparkle particles */
.camera-wrap {
  position: relative;
}
.sparkle-container {
  position: absolute;
  inset: -8px;
  z-index: 0;
  pointer-events: none;
}
.sparkle {
  position: absolute;
  opacity: 0;
  width: 8px;
  height: 8px;
  animation: sparkle-twinkle 2.5s ease-in-out infinite;
}
.sparkle::before {
  content: "";
  position: absolute;
  inset: 0;
  background: currentColor;
  clip-path: polygon(50% 0%, 62% 38%, 100% 50%, 62% 62%, 50% 100%, 38% 62%, 0% 50%, 38% 38%);
}
.s1 { top: -5px; left: 50%; animation-delay: 0s; }
.s2 { top: 15%; right: -7px; animation-delay: 0.4s; width: 10px; height: 10px; }
.s3 { bottom: -3px; left: 25%; animation-delay: 0.9s; width: 6px; height: 6px; }
.s4 { top: 25%; left: -7px; animation-delay: 1.4s; }
.s5 { bottom: 5%; right: -6px; animation-delay: 1.8s; width: 6px; height: 6px; }
.s6 { top: -4px; left: 18%; animation-delay: 2.2s; width: 6px; height: 6px; }
.sparkle-fresh .s1, .sparkle-fresh .s3, .sparkle-fresh .s5 { color: #fff; }
.sparkle-fresh .s2, .sparkle-fresh .s6 { color: #3FC668; }
.sparkle-fresh .s4 { color: #2ecda7; }
.sparkle-reef .s1, .sparkle-reef .s3, .sparkle-reef .s5 { color: #fff; }
.sparkle-reef .s2, .sparkle-reef .s6 { color: #3b7dff; }
.sparkle-reef .s4 { color: #2eded1; }
@keyframes sparkle-twinkle {
  0%, 100% { opacity: 0; transform: scale(0) rotate(0deg); }
  20% { opacity: 1; transform: scale(1) rotate(15deg); }
  50% { opacity: 0.6; transform: scale(0.5) rotate(30deg); }
  70% { opacity: 1; transform: scale(1.2) rotate(45deg); }
  90% { opacity: 0; transform: scale(0) rotate(60deg); }
}
</style>
